const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "tom I, rozdz. X, s. 386",
    title: "Nasz wspólny przyjaciel",
    desc: "„Jeżeli chcesz zrobić coś dobrego, dlaczego nie zrobić tego dla samego dobra, a odrzucić precz swoje lubienia i przyjemności?“",
    rate: "1861'",
  },
  {
    id: 2,
    category: "education",
    year: "ks. 1, rozdz. 10",
    title: "Mała Dorrit",
    desc: "„Ministerstwo Przelewania z Pustego w Próżne.“",
    rate: "1857'",
  },
  {
    id: 3,
    category: "education",
    year: "scena, rozdz. 22",
    title: "Szkice Boza",
    desc: "„Żal nigdy nie naprawił złamanych kości, a ponieważ dobrzy ludzie są bardzo rzadcy, mówię, że wykorzystaj je jak najlepiej”.",
    rate: "1836'",
  },
  {
    id: 4,
    category: "experience",
    year: "rozd. 27",
    title: "Wielkie nadzieje",
    desc: "„Pip, drogi staruszku, życie składa się z wielu zespawanych ze sobą podziałów…”",
    rate: "1860'",
  },
  {
    id: 5,
    category: "experience",
    year: "część III, rozd. 1 ",
    title: "Ciężkie czasy",
    desc: "„Istnieje mądrość Głowy i … jest mądrość Serca.”",
    rate: "1854'",
  },
  {
    id: 6,
    category: "experience",
    year: "tom I",
    title: "Zegar Mistrza Humphreya",
    desc: "„Ukrywanie czegokolwiek przed tymi, do których jestem przywiązany, nie leży w mojej naturze. Nigdy nie mogę zamknąć ust tam, gdzie otworzyłem serce.”",
    rate: "1840'",
  },
];

export default ResumeApi;
